export const getColors = () => {
  const colorData = [
    "--ch-text-head",
    "--ch-blue-100",
    "--ch-blue-200",
    "--ch-blue-300",
    "--ch-blue-400",
    "--ch-secondary",
    "--ch-black",
    "--ch-input",
    "--ch-danger"
  ];

  return colorData;
};
